module.exports = __webpack_public_path__ + "static/media/checkout.63df1c5c.png";